<template>
  <div id="master">
    <MainHeaderSimple>
      <template #fixed>
        <SubscriptionStatusAlert />
      </template>
    </MainHeaderSimple>

    <FloatingActionMenu />

    <main>
      <SearchContainer />

      <router-view
        :key="$route.path"
      ></router-view>
    </main>

    <MainFooter />
  </div>
</template>

<script>
  import MainHeaderSimple from '@/components/layout/MainHeaderSimple'
  import MainFooter from '@/components/layout/MainFooter'
  import SubscriptionStatusAlert from '@/components/subscription/SubscriptionStatusAlert'
  import SearchContainer from '@/components/search/SearchContainer'
  import FloatingActionMenu from '@/components/layout/FloatingActionMenu'

  export default {
    components: {
      MainHeaderSimple,
      MainFooter,
      SubscriptionStatusAlert,
      SearchContainer,
      FloatingActionMenu,
    },
  }
</script>